module.exports = __webpack_public_path__ + "static/media/logo.491d83c7.svg";